var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

/**
 * United Trucks — standalone site JS (Bootstrap 5, no Filter Pro shared init)
 *
 * Import only what you need — each import registers its data-bs-* handlers.
 * Requires @popperjs/core (Dropdown, Popover, Tooltip).
 */

// import Alert from 'bootstrap-v5/js/dist/alert';
// import Button from 'bootstrap-v5/js/dist/button';
// import Carousel from 'bootstrap-v5/js/dist/carousel';
import Collapse from 'bootstrap-v5/js/dist/collapse';
import Dropdown from 'bootstrap-v5/js/dist/dropdown';
import Modal from 'bootstrap-v5/js/dist/modal';
import Offcanvas from 'bootstrap-v5/js/dist/offcanvas';
// import Popover from 'bootstrap-v5/js/dist/popover';
// import ScrollSpy from 'bootstrap-v5/js/dist/scrollspy';
// import Tab from 'bootstrap-v5/js/dist/tab';
// import Toast from 'bootstrap-v5/js/dist/toast';
// import Tooltip from 'bootstrap-v5/js/dist/tooltip';
require('bootstrap-datepicker');


window.bootstrap = {
    // Alert,
    // Button,
    // Carousel,
    Collapse,
    Dropdown,
    Modal,
    Offcanvas,
    // Popover,
    // ScrollSpy,
    // Tab,
    // Toast,
    // Tooltip,
};

// alert('test')

import feather from 'feather-icons';
import MmenuLight from 'mmenu-light';

$(function() {

    $('.date-picker-input').datepicker({
        format: 'dd/mm/yyyy', // Customize date format
        autoclose: true,      // Close the datepicker automatically after selection
        todayHighlight: true,  // Highlight the current date
        orientation: 'bottom'
    });

    $('.reset-filter').on('click', function (e) {
        e.preventDefault();
        $(this).closest('form').find(':text').val('').end().submit();
    });
});

window.initFeatherIcons = function (root) {
    feather.replace({
        'aria-hidden': 'true',
        class: 'feather',
    }, root || document);
};

document.addEventListener('DOMContentLoaded', () => {
    window.initFeatherIcons();

    initMobileMenu();
    initBreadcrumbAutoScroll();

    document.querySelectorAll('.main-nav [data-bs-toggle="dropdown"]').forEach((toggle) => {
        toggle.addEventListener('show.bs.dropdown', () => {
            const filter = document.getElementById('offcanvasFilter');
            if (filter?.classList.contains('show')) {
                Offcanvas.getOrCreateInstance(filter).hide();
            }
        });

        toggle.addEventListener('shown.bs.dropdown', (event) => {
            window.initFeatherIcons(event.target.closest('.dropdown'));
        });
    });

});

/**
 * On mobile devices, auto scroll breadcrumbs horizontally to the last item when overflowing.
 */
function initBreadcrumbAutoScroll() {
    const scrollBreadcrumbs = (smooth = true) => {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;
        const isMobile = window.innerWidth <= 991.98 || (window.matchMedia && window.matchMedia('(max-width: 991.98px)').matches);
        if (!isMobile) return;

        const nav = document.querySelector('nav[aria-label="breadcrumb"]');
        const ol = document.querySelector('ol.breadcrumb');
        if (!ol) return;

        const container = (nav && nav.scrollWidth > nav.clientWidth) ? nav
                        : (ol.scrollWidth > ol.clientWidth ? ol : nav || ol);

        if (container && container.scrollWidth > container.clientWidth) {
            const targetLeft = container.scrollWidth - container.clientWidth;
            if (typeof container.scrollTo === 'function') {
                container.scrollTo({ left: targetLeft, behavior: smooth ? 'smooth' : 'auto' });
            } else {
                container.scrollLeft = targetLeft;
            }
        }
    };

    window.scrollBreadcrumbsToLast = scrollBreadcrumbs;

    // Auto-scroll on initial load after brief delay for fonts/layout to settle
    setTimeout(() => scrollBreadcrumbs(true), 150);

    // Re-check once window fully loads
    window.addEventListener('load', () => {
        setTimeout(() => scrollBreadcrumbs(false), 50);
    });

    // Re-check on viewport resize (e.g. orientation change)
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => scrollBreadcrumbs(false), 150);
    });
}



function initMobileMenu() {
    const menuNode = document.querySelector('#mobile-menu');
    const openButton = document.querySelector('#mobile-menu-open');

    if (!menuNode || !openButton) {
        return;
    }

    menuNode.classList.remove('d-none');
    menuNode.classList.add('d-flex');

    const menu = new MmenuLight(menuNode, '(max-width: 991.98px)');

    menu.navigation({
        title: 'Menu',
        theme: 'dark',
    });

    const drawer = menu.offcanvas({
        position: 'left',
    });

    const updateButton = (isOpen) => {
        // openButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        // openButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
        openButton.innerHTML = `<i data-feather="${isOpen ? 'x' : 'menu'}" width="32" height="32"></i>`;
        window.initFeatherIcons(openButton);
    };

    const open = drawer.open.bind(drawer);
    const close = drawer.close.bind(drawer);
    drawer.open = () => { open(); updateButton(true); };
    drawer.close = () => { close(); updateButton(false); };

    openButton.addEventListener('click', (event) => {
        event.preventDefault();
        drawer.wrapper.classList.contains('mm-ocd--open') ? drawer.close() : drawer.open();
    });
}
